import Vue from "vue";
import App from "../App/App.vue";
import Colloquium from "./Colloquium.vue";
var vm = window.$vm = new Vue({
    name: "App",
    el: "app",
    components: {
        App: App,
        Colloquium: Colloquium
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/Colloquium/Index.cshtml.ts
// module id = 1222
// module chunks = 0